// extracted by mini-css-extract-plugin
export var activeFilterButton = "_pb-c";
export var backButton = "_pb-4";
export var backIcon = "_pb-5";
export var chevronShortcut = "_pb-6";
export var container = "_pb-1";
export var editor = "_pb-8";
export var editorWrapper = "_pb-7";
export var prefix = "_pb-2";
export var searchIcon = "_pb-3";
export var suffix = "_pb-9";
export var suffixContent = "_pb-a";
export var suffixText = "_pb-b";
export var wrapper = "_pb-0";